import { useNavigate } from 'react-router-dom';
import { TableColumn } from '../../components/DataTable/TableColumn';
import { TextColumn } from '../../components/DataTable/TextColumn';
import { BoolColumn } from '../../components/DataTable/BoolColumn';
import { DateColumn } from '../../components/DataTable/DateColumn';
import { CouponSummary } from '../../interfaces/Coupon/CouponSummary';
import { CouponType } from '../../interfaces/Coupon/CouponType';
import { formatCurrency } from '../../utils/Currency';
import { Pagination } from '../../interfaces/Pagination';
import { DataTable } from '../../components/DataTable/DataTable';

const columns: TableColumn<CouponSummary>[] = [
  {
    id: 'id',
    name: 'ID',
    accessor: (row) => <TextColumn value={row.id.toString()} />,
  },
  {
    id: 'code',
    name: 'Kupon Kodu',
    accessor: (row) => <TextColumn value={row.code} />,
  },
  {
    id: 'name',
    name: 'İsim',
    accessor: (row) => <TextColumn value={row.name} />,
  },
  {
    id: 'value',
    name: 'İndirim',
    accessor: (row) => (
      <TextColumn
        value={
          row.type === CouponType.FIXED
            ? formatCurrency(row.value)
            : `%${row.value.toFixed(2)}`
        }
      />
    ),
  },
  {
    id: 'start-at',
    name: 'Başlangıç',
    accessor: (row) => <DateColumn value={row.startAt} />,
  },
  {
    id: 'end-at',
    name: 'Bitiş',
    accessor: (row) => <DateColumn value={row.endAt} />,
  },
  {
    id: 'is-active',
    name: 'Durum',
    accessor: (row) => <BoolColumn value={row.isActive} />,
    align: 'center',
  },
  {
    id: 'created-at',
    name: 'Oluşturulma Tarihi',
    accessor: (row) => <DateColumn value={row.createdAt} />,
  },
  {
    id: 'updated-at',
    name: 'Düzenlenme Tarihi',
    accessor: (row) => <DateColumn value={row.updatedAt} />,
  },
];

type CouponsTableProps = {
  coupons: CouponSummary[];
  totalCount: number;
  pagination: Pagination;
  onPagination: (newPagination: Pagination) => void;
};

export const CouponsTable = (props: CouponsTableProps) => {
  const navigate = useNavigate();

  return (
    <DataTable
      columns={columns}
      totalCount={props.totalCount}
      rows={props.coupons}
      limit={props.pagination.pageSize}
      setLimit={(newLimit) =>
        props.onPagination({ page: 0, pageSize: newLimit })
      }
      page={props.pagination.page}
      setPage={(newPage) =>
        props.onPagination({ ...props.pagination, page: newPage })
      }
      onClick={(coupon) => navigate(`/sales/coupons/${coupon.id}`)}
    />
  );
};
